import React from 'react';
import styled from 'styled-components';

interface FooterContainerProps {
  $isCollapsed: boolean;
}

const FooterContainer = styled.footer<FooterContainerProps>`
  position: fixed;
  bottom: 0;
  right: 0;
  width: calc(100% - ${props => props.$isCollapsed ? '70px' : '240px'});
  background-color: #f8f9fa;
  padding: 15px 20px;
  text-align: left;
  border-top: 1px solid #eaeaea;
  transition: width 0.3s ease;
  z-index: 10;

  @media (max-width: 768px) {
    width: 100%;
    padding: 12px 15px;
  }
`;

const FooterText = styled.p`
  color: #6c757d;
  margin: 0;
  font-size: 14px;

  span {
    color: #495057;
  }
`;

interface FooterProps {
  isCollapsed: boolean;
}

const Footer: React.FC<FooterProps> = ({ isCollapsed }) => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer $isCollapsed={isCollapsed}>
      <FooterText>
        Copyright © <span>{currentYear}</span> All rights reserved.
      </FooterText>
    </FooterContainer>
  );
};

export default Footer; 